import { render, staticRenderFns } from "./list_agama.vue?vue&type=template&id=838244cc&"
import script from "./list_agama.vue?vue&type=script&lang=js&"
export * from "./list_agama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QCard,QCardSection,QBtn,QMarkupTable,QPagination,QDialog,QInput,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QCard,QCardSection,QBtn,QMarkupTable,QPagination,QDialog,QInput,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
